<template>
  <div class="announcement-modal-content">
    <slot></slot>
    <img :src="src" :srcset="srcset" alt="" class="announcement-modal-content__image" />
  </div>
</template>
<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'AnnoucementModalContent',
  props: {
    image: {
      type: String,
      required: true,
    },
  },
  computed: {
    imageName(): string {
      return this.$device.isMobile ? `${this.image}-mobile` : this.image;
    },
    src(): string {
      return require(`./images/${this.imageName}.png`);
    },
    srcset(): string {
      return `${require(`./images/${this.imageName}.png`)}, ${require(`./images/${this.imageName}@2x.png`)} 2x, ${require(`./images/${this.imageName}@3x.png`)} 3x`;
    },
  },
});
</script>

<style scoped lang="scss">
.announcement-modal-content {
  display: flex;
  flex-direction: column;
  background: linear-gradient(97.4deg, #15191f 0%, #192337 100%);
  width: 348px;
  padding: 24px 24px 0;
  border-radius: 16px;
  box-shadow: 0 12px 12px rgba(86, 86, 86, 0.25);
  align-self: flex-start;
  overflow: hidden;

  @media only screen and (max-device-width: 348px) {
    width: 100%;
    min-height: 100vh;
    margin-top: 0;
    border-radius: 0;
    justify-content: space-between;
  }

  @include mq('sm') {
    height: 291px;
    width: 640px;
    flex-direction: row;
    padding: 0;
    align-self: auto;
  }

  &__image {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    max-width: 100%;
    height: auto;

    @include mq('sm') {
      border-top-right-radius: 0;
      padding-top: 24px;
      align-self: flex-end;
      width: 320px;
    }
  }
}
</style>
